import type { ReactNode } from 'react';
import { mergeStyling } from '../common-functions';

interface ErrorLabelProps {
  children: ReactNode;
  className?: string;
  role?: string;
}

export default function ErrorLabel({ children, className, role }: ErrorLabelProps) {
  const errorLabelClasses = mergeStyling('mt-1 text-xs text-error', className);
  return (
    <span className={errorLabelClasses} role={role}>
      {children}
    </span>
  );
}
